import React from "react";
import SideMenu from "../sharedScreens/menuItems/SideMenu";
import MuiButton from "../components/basicComponent/MuiButton";
import MuiSearchSelect from "../components/basicComponent/MuiSearchSelect";
import Header from "../sharedScreens/Header";
import Switch from "@mui/material/Switch";
import { MuiInput } from "../components/basicComponent/MuiInput";

const Suppliers = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Suppliers</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Supplier"}
                          label="Supplier "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div className="col-md-2 mt-2   ">
                        <div>
                          <div className=" w-full">
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Get"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div
                        data-datatable="true"
                        data-datatable-page-size={20}
                        className="datatable-initialized"
                      >
                        <div className="scrollable-x-auto">
                          <div
                            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                            data-datatable-spinner="true"
                            style={{ display: "none" }}
                          >
                            <div className="flex items-center gap-2 px-4 py-2 font-medium leading-none text-2sm border border-gray-200 shadow-default rounded-md text-gray-500 bg-light">
                              <svg
                                className="animate-spin -ml-1 h-5 w-5 text-gray-600"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx={12}
                                  cy={12}
                                  r={10}
                                  stroke="currentColor"
                                  strokeWidth={3}
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                />
                              </svg>
                              Loading...
                            </div>
                          </div>
                          <table
                            className="table table-border"
                            data-datatable-table="true"
                          >
                            <thead>
                              <tr>
                                <th className="w-14 text-center">
                                  <span className="sort ">
                                    Product
                                    <span className="sort-icon"></span>
                                  </span>
                                </th>
                                <th className="min-w-[200px] text-center">
                                  <span className="sort ">
                                    Supplier
                                    <span className="sort-icon"></span>
                                  </span>
                                </th>
                                <th className="w-[180px] text-center">
                                  <span className="sort ">
                                    Username
                                    <span className="sort-icon"></span>
                                  </span>
                                </th>
                                <th className="min-w-[170px] text-center">
                                  <span className="sort">
                                    Password
                                    <span className="sort-icon"></span>
                                  </span>
                                </th>
                                <th className="min-w-[140px] text-center">
                                  <span className="sort ">
                                    FareType
                                    <span className="sort-icon"></span>
                                  </span>
                                </th>
                                <th className="w-[140px] text-center">
                                  <span className="sort">
                                    Status
                                    <span className="sort-icon"></span>
                                  </span>
                                </th>
                                <th className="w-[140px] text-center">
                                  <span className="sort">
                                  validity
                                    <span className="sort-icon"></span>
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="checked">
                                <td>
                                  <span className=" text-sm font-normal text-gray-700">
                                    AIRLINE
                                  </span>{" "}
                                </td>
                                <td className="text-center">
                                  <span className=" text-sm font-normal text-gray-700">
                                    BC API-UAI
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="text-sm font-normal text-gray-700">
                                    info@ewts.ae
                                  </span>
                                </td>
                                <td className="tect-center">
                                  <span className="text-sm font-normal text-gray-700 user-manage-model">
                                  <MuiInput label={"password"}/>
                                  </span>
                                </td>
                                <td className="text-gray-800 font-normal user-manage-model">
                                  <MuiSearchSelect
                                    placeholder={""}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </td>
                                <td className="text-gray-800 font-normal text-center">
                                  <Switch />
                                </td>
                                <td className="text-gray-800 font-normal text-center">
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span className=" text-sm font-normal text-gray-700">
                                    AIRLINE
                                  </span>{" "}
                                </td>
                                <td className="text-center">
                                  <span className=" text-sm font-normal text-gray-700">
                                    BC API-UAI
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="text-sm font-normal text-gray-700">
                                    info@ewts.ae
                                  </span>
                                </td>
                                <td className="tect-center">
                                  <span className="text-sm font-normal text-gray-700 user-manage-model">
                                  <MuiInput label={"password"}/>
                                  </span>
                                </td>
                                <td className="text-gray-800 font-normal user-manage-model">
                                  <MuiSearchSelect
                                    placeholder={""}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </td>
                                <td className="text-gray-800 font-normal text-center">
                                  <Switch />
                                </td>
                              </tr>
                              <tr className="checked">
                                <td>
                                  <span className=" text-sm font-normal text-gray-700">
                                    AIRLINE
                                  </span>{" "}
                                </td>
                                <td className="text-center">
                                  <span className=" text-sm font-normal text-gray-700">
                                    BC API-UAI
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="text-sm font-normal text-gray-700">
                                    info@ewts.ae
                                  </span>
                                </td>
                                <td className="tect-center">
                                  <span className="text-sm font-normal text-gray-700 user-manage-model">
                                  <MuiInput label={"password"}/>
                                  </span>
                                </td>
                                <td className="text-gray-800 font-normal user-manage-model">
                                  <MuiSearchSelect
                                    placeholder={""}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </td>
                                <td className="text-gray-800 font-normal text-center">
                                  <Switch />
                                </td>
                              </tr>
                              <tr className="checked">
                                <td>
                                  <span className=" text-sm font-normal text-gray-700">
                                    AIRLINE
                                  </span>{" "}
                                </td>
                                <td className="text-center">
                                  <span className=" text-sm font-normal text-gray-700">
                                    BC API-UAI
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="text-sm font-normal text-gray-700">
                                    info@ewts.ae
                                  </span>
                                </td>
                                <td className="tect-center">
                                  <span className="text-sm font-normal text-gray-700 user-manage-model">
                                  <MuiInput label={"password"}/>
                                  </span>
                                </td>
                                <td className="text-gray-800 font-normal user-manage-model">
                                  <MuiSearchSelect
                                    placeholder={""}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </td>
                                <td className="text-gray-800 font-normal text-center">
                                  <Switch />
                                </td>
                              </tr>
                              <tr className="checked">
                                <td>
                                  {" "}
                                  <span className=" text-sm font-normal text-gray-700">
                                    AIRLINE
                                  </span>{" "}
                                </td>
                                <td className="text-center">
                                  <span className=" text-sm font-normal text-gray-700">
                                    {" "}
                                    BC API-UAI
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="text-sm font-normal text-gray-700">
                                    info@ewts.ae
                                  </span>
                                </td>
                                <td className="tect-center">
                                  <span className="text-sm  font-normal text-gray-700 user-manage-model">
                                   <MuiInput label={"Password"}/>
                                  </span>
                                </td>
                                <td className="text-gray-800 font-normal user-manage-model">
                                  <MuiSearchSelect
                                    placeholder={""}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </td>
                                <td className="text-gray-800 font-normal text-center">
                                  <Switch />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div>
                          <div className=" user-button">
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Submit"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Suppliers;
